module.exports = __webpack_public_path__ + "img/1462985662.6f7959a4.jpg";